import { FC, HTMLAttributes } from 'react';
import { TSCard } from '../../../components/shared/card/Card';
import { isAdmin, useAuthenticationService } from '../authentication-service';
import { useLocationService } from '../../location/LocationService';

interface RequireAssignedLocationProps extends HTMLAttributes<HTMLDivElement> {
  locationIds: string[];
  errorMessage: string;
}

export const RequireAssignedLocation: FC<RequireAssignedLocationProps> = ({ locationIds, errorMessage, children }) => {
  const locationList = useLocationService(state => state.locationList);
  const [role] = useAuthenticationService(state => [state.role]);

  const checkLocationList = () => {
    // Admins can access all locations regardless of which locations they are assigned to.
    if (isAdmin(role)) {
      return true;
    }

    return locationIds.every(id => locationList.some(loc => loc.id.toString() === id));
  };

  const canView = checkLocationList();

  return <>{canView ? children : <TSCard className="text-center p-5">{errorMessage}</TSCard>}</>;
};
